import styled, {css} from "styled-components";
import {Color} from "../Common/Colors";

const StyledImageFluid = styled.img`
  max-width: 100%;
  height: auto;
 
  ${props => (props.backgroundColor) && css`
    background-color: ${props => props.backgroundColor};
  `}

  ${props => (props.borderTopRadius) && css`
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  `}

  ${props => (props.borderBottomRadius) && css`
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  `}

  ${props => (props.rounded) && css`
    border-radius: 0.5rem;
  `}

  ${props => (props.borderBottomPlatinum) && css`
    border-bottom: 1px solid ${Color.platinum};
  `}

  ${props => (props.borderPlatinum) && css`
    border: 1px solid ${Color.platinum};
  `}

  ${props => (props.borderDarkgunmetal) && css`
    border: 1px solid ${Color.darkgunmetal};
  `}
  
`;

export default StyledImageFluid;
